export default function () {
    return {
        futureDeliveryRequests: [],
    };
}
